import React from 'react';
import { BUDGET_TYPE } from '../constants/otrEnums';

export const ExpenseHeadTable = ({
  policyHeads,
  userSelections,
  onSelectionChange,
  tripDays,
  isReadOnly = false,
  currencySymbol = '₹',
  emptyMessage = 'No expense heads configured for this tier.'
}) => {
  return (
    <div className="overflow-hidden rounded-2xl border border-[var(--color-border)] bg-white shadow-sm">
      <table className="max-md:block w-full text-left border-collapse">
        <thead className="max-md:hidden">
          <tr className="bg-[var(--color-workspace)]/50 border-b border-[var(--color-border)]">
            <th className="px-5 py-4 text-[11px] font-bold text-[var(--color-text-secondary)] uppercase tracking-wider">Expense Head</th>
            <th className="px-5 py-4 text-[11px] font-bold text-[var(--color-text-secondary)] uppercase tracking-wider text-center">Budget Type</th>
            <th className="px-5 py-4 text-[11px] font-bold text-[var(--color-text-secondary)] uppercase tracking-wider text-right">Max Limit</th>
            <th className="px-5 py-4 text-[11px] font-bold text-[var(--color-text-secondary)] uppercase tracking-wider text-center">Company Arranged</th>
          </tr>
        </thead>
        <tbody className="max-md:block divide-y divide-[var(--color-border)]">
          {policyHeads.map((head) => {
            const isCompanyArrangedAllowed = head.companyArranged;
            const isSelected = !!(userSelections || {})[String(head.expenseId ?? head.headId)];

            let limitDisplay = 'N/A';
            if (head.budgetType === BUDGET_TYPE.PER_DAY) {
              limitDisplay = `${currencySymbol} ${head.defaultAmount} / day`;
            } else if (head.budgetType === BUDGET_TYPE.LUMPSUM) {
              limitDisplay = `${currencySymbol} ${head.defaultAmount}`;
            } else if (head.budgetType === BUDGET_TYPE.AT_ACTUALS) {
              limitDisplay = 'At Actuals';
            }

            return (
              <tr key={head.expenseId ?? head.headId} className="max-md:block max-md:px-4 max-md:py-3 hover:bg-[var(--color-workspace)]/20 transition-colors">
                <td data-label="Expense Head" className="max-md:flex max-md:items-center max-md:justify-between max-md:gap-3 max-md:px-0 max-md:py-1.5 max-md:text-right max-md:before:content-[attr(data-label)] max-md:before:text-[10px] max-md:before:font-bold max-md:before:uppercase max-md:before:tracking-wider max-md:before:text-left max-md:before:text-[var(--color-text-secondary)] max-md:before:shrink-0 px-5 py-4 text-sm font-bold text-foreground">{head.headName}</td>
                <td data-label="Budget Type" className="max-md:flex max-md:items-center max-md:justify-between max-md:gap-3 max-md:px-0 max-md:py-1.5 max-md:text-right max-md:before:content-[attr(data-label)] max-md:before:text-[10px] max-md:before:font-bold max-md:before:uppercase max-md:before:tracking-wider max-md:before:text-left max-md:before:text-[var(--color-text-secondary)] max-md:before:shrink-0 px-5 py-4 text-center">
                  <span className="inline-block px-2 py-0.5 rounded-md bg-slate-100 text-[10px] font-bold text-slate-600 uppercase">
                    {head.budgetType}
                  </span>
                </td>
                <td data-label="Max Limit" className="max-md:flex max-md:items-center max-md:justify-between max-md:gap-3 max-md:px-0 max-md:py-1.5 max-md:text-right max-md:before:content-[attr(data-label)] max-md:before:text-[10px] max-md:before:font-bold max-md:before:uppercase max-md:before:tracking-wider max-md:before:text-left max-md:before:text-[var(--color-text-secondary)] max-md:before:shrink-0 px-5 py-4 text-sm font-medium text-right text-[var(--color-text-secondary)]">
                  {limitDisplay}
                </td>
                <td data-label="Company Arranged" className="max-md:flex max-md:items-center max-md:justify-between max-md:gap-3 max-md:px-0 max-md:py-1.5 max-md:text-right max-md:before:content-[attr(data-label)] max-md:before:text-[10px] max-md:before:font-bold max-md:before:uppercase max-md:before:tracking-wider max-md:before:text-left max-md:before:text-[var(--color-text-secondary)] max-md:before:shrink-0 px-5 py-4 text-center">
                  <div className="flex justify-center">
                    <button
                      type="button"
                      disabled={isReadOnly || !isCompanyArrangedAllowed}
                      onClick={() => onSelectionChange(head.expenseId ?? head.headId, !isSelected)}
                      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)]/20 ${
                        isSelected ? 'bg-[var(--color-primary)]' : 'bg-slate-200'
                      } ${!isCompanyArrangedAllowed ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}
                    >
                      <span
                        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                          isSelected ? 'translate-x-6' : 'translate-x-1'
                        }`}
                      />
                    </button>
                  </div>
                  {!isCompanyArrangedAllowed && (
                    <div className="text-[9px] text-[var(--color-error)] mt-1 font-medium">Not Allowed</div>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {policyHeads.length === 0 && (
        <div className="py-12 text-center text-sm text-[var(--color-text-secondary)] italic">
          {emptyMessage}
        </div>
      )}
    </div>
  );
};